

interface String {
    replaceAll: (toreplace: string, replacewith: string) => string;
    toNumber: () => number;
    log: (name: string) => void;
    logWithObject: (name: string, obj: Object) => void;
    ErrorWithObject: (name: string, obj: Object) => void;
    EmptyGuid: () => string;
    Env: () => string;
}

String.prototype.Env = function () {
    return 'Dev';
};

String.prototype.replaceAll = function (toreplace, replacewith) {
    const s = String(this);
    return s.split(toreplace).join(replacewith);
};

/**
 * takes a string and retuns its number
 * will return zero if not found
 */
String.prototype.toNumber = function () {
    const s = String(this).toUpperCase();
    let ret = 0;
    switch (s) {
        case 'ONE':
            ret = 1;
            break;
        case 'TWO':
            ret = 2;
            break;
        case 'THREE':
            ret = 3;
            break;
        case 'FOUR':
            ret = 4;
            break;
        case 'FIVE':
            ret = 5;
            break;
        case 'SIX':
            ret = 6;
            break;
        case 'SEVEN':
            ret = 7;
            break;
        case 'EIGHT':
            ret = 8;
            break;
        case 'NINE':
            ret = 9;
            break;
        case 'TEN':
            ret = 10;
            break;
        case 'ELEVEN':
            ret = 11;
            break;
        case 'TWELVE':
            ret = 12;
            break;
        case 'SUBMIT':
            ret = 100;
            break;
        default:
            ret = 0;
    }
    return ret;
};

String.prototype.log = function (name) {
    if ('this'.Env() === 'Dev') {
        //console.log('PACED | LOG | ' + name + ' | ' + String(this));
    }
};

String.prototype.logWithObject = function (name, obj) {
    if ('this'.Env() === 'Dev') {
        // console.log(
        //     ('PACED | LOG | ' + name + ' | ' + String(this)), obj);
    }
};

String.prototype.ErrorWithObject = function (name, obj) {
    if ('this'.Env() === 'Dev') {
        // console.log(
        //     ('PACED | ERROR | ' + name + ' | ' + String(this)), obj);
    }
};

String.prototype.EmptyGuid = function () {
    return '00000000-0000-0000-0000-000000000000';
};








// WEBPACK FOOTER //
// C:/AZURE/ACEP/Acep.Crm.WebPortal/CrmWebPortalGlobal/Membership/AngularApps/PACED/PACEDAngular/src/app/Prototypes/p-string.ts